import { render, staticRenderFns } from "./ProjectMenuSidebar.vue?vue&type=template&id=6f9c28a8&scoped=true&"
import script from "./ProjectMenuSidebar.vue?vue&type=script&lang=js&"
export * from "./ProjectMenuSidebar.vue?vue&type=script&lang=js&"
import style0 from "./ProjectMenuSidebar.vue?vue&type=style&index=0&id=6f9c28a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9c28a8",
  null
  
)

export default component.exports